import { ExternalLogin } from "../../features";

export function ExternalLoginPage() {
  return (
    <div className="position-fixed h-100 w-100 login-container-bg overflow-auto">
      <ExternalLogin />
    </div>
  );
}
